export const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID as string;
